import { Link } from 'react-router-dom';
import { useDocumentMeta } from '@/lib/useDocumentMeta';

// One entry per monthly audit. The rate-audit routine appends here.
const POSTS = [
  {
    slug: 'hysa-rates-august-2026',
    date: 'August 2026',
    title: 'HYSA rate check: August 2026',
    excerpt:
      'We audited 34 accounts this month. Vio Bank leads open standing rates at 3.99% APY, Axos reaches 4.21% with direct-deposit conditions, and the tax-equivalent leader for most profiles is FutureMoney Reserve at about 5.00%.',
  },
];

export default function Blog() {
  useDocumentMeta(
    'Rate reports · RateMyHYSA',
    'Monthly audits of every high-yield savings rate we track, with archived screenshots.'
  );

  return (
    <main className="band">
      <div className="wrap">
        <div className="section-head">
          <div className="eyebrow">Rate reports</div>
          <h2>The monthly audit</h2>
          <p>
            Every month we re-check each rate on the institution&rsquo;s own website, archive a
            screenshot for the record, and publish what changed.
          </p>
        </div>
        <div className="post-list">
          {POSTS.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="post-card">
              <div className="post-date">{p.date}</div>
              <h3>{p.title}</h3>
              <p>{p.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
